<template>
    <div class="card" id="card">
        <div class="row header">
            <img :src="iconImage" />
            <h3>
                {{ name }}
            </h3>
            <h3>
                <strong class="gold-text">{{ Math.round(rating) }}/5</strong>
            </h3>
        </div>
        <div class="subheader" v-if="expanded">
            <p class="minor-text">{{ description }} </p>
        </div>
        <div class="body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "MetricCard",
    props: {
        name: String,
        title: String,
        rating: Number,
    },
    computed: {
        iconImage() {
            return require(`@/assets/icons/metrics/${this.name.toLowerCase()}-icon.svg`);
        },
    },
    methods: {},
    data() {
        let descriptions = {
			// Nick's orig copy text: "Workload is consisted of rough weekly time commitment, if it increases/decreases throughout"
            Workload: "Workload consists of a rough weekly estimation of where students spend time on average in a given week",
            Difficulty: "Relevance maps to the most closely related jobs in industry for this course",
            Relevance: "Difficulty rating provides insights on what makes this class is easy or hard",
            Professor: "Professor rating gives you a quick glimpse on pros/cons for each professor",
        };
        return {
            description: descriptions[this.name],
            expanded: false,
        };
    },
    created() {
        this.$on("expand", () => {
            this.expanded = !this.expanded;
        });
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/styles/_main.scss";

/deep/ .card,
.card {
    padding: 36px;

    width: 100%;

    background-color: #fafafa;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    border-radius: 12px;
}

.header {
    display: grid;
    grid-template-columns: auto auto auto;
    column-gap: 15px;
    align-items: center;

    width: fit-content;
}

.body {
    margin-top: 30px;
}

h3 {
    color: #666666;
}

p {
    font-size: 14px;
}

@media only screen and (max-width: $breakpoint-small) {
    h3 {
        font-size: 18px;
    }

    .card {
        padding: 24px;
    }

    .body {
        margin-top: 16px;
    }
}
</style>
